<template>
  <tr :class="{ extra: extra }" class="listener--show">
    <td>
      {{ item.work_type.name }}
    </td>
    <td>
      {{ $formatDate(item.start_date) + ' - ' + $formatDate(item.end_date) }}
    </td>
    <td>
      {{
        item.work_type.is_hourly === 0
          ? $roundNumberToTenths(item.employee_done) + ' ' + item.work_type.measure
          : $formatTime($roundNumberToTenths(item.employee_done))
      }}
    </td>
  </tr>
</template>

<script>
// import EmployeesPhoto from 'components/employees/EmployeesPhoto'

export default {
  name: 'TimeControlShowGridEmployeeItem',
  // components: { EmployeesPhoto },
  props: {
    item: Object,
    tableHead: Array,
    extra: Boolean,
    min: Boolean,
  },
  data: () => ({
    open: false,
  }),
  methods: {
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
  },
}
</script>
